




























































import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import { ObjectId } from "@/types";
import { Emit } from "vue-property-decorator";

export interface InterbankDateItem {
  yearmonth: string; //振替日
}

@Component({
  components: {}
})
export default class InterbankDate extends Vue {
  private get dateFormatted(): string {
    if (!this.yearmonth) {
      return "";
    } else {
      const [year, month] = this.yearmonth.split("-");
      return `${year}年${month}月${this.day}日`;
    }
  }

  //振替年月
  public yearmonth = "";

  //振替日
  public day = "";

  //開いているかどうか
  private interbankDate = false;

  //開く
  public open() {
    this.interbankDate = true;
  }

  //口座振替データ出力
  @Emit("interbankFormatDisplay")
  private interbankFormatDisplay() {
    this.interbankDate = false;
    //emitで送る用
    const item: InterbankDateItem = {
      yearmonth: this.yearmonth
    };
    return item;
  }

  //キャンセル
  private cancel() {
    this.interbankDate = false;
  }
}
